import { defineMessages } from "react-intl";

const PREFIX = "Subscriptions.SubscriptionsMenu";

export const messages = defineMessages({
  noSubscriptions: {
    id: `${PREFIX}.noSubscriptions`,
    defaultMessage: "The Subscriptions section is empty",
  },
});
